<template>
  <div>
    <loading v-if="isLoading" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="password-card">
        <v-toolbar color="#006699" dark flat>
          <v-toolbar-title>
            <v-icon left>mdi-lock-reset</v-icon>
            Alterar Senha
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharComponente">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-container>
            <v-form ref="form" v-model="formValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.nomeUsuario" 
                    label="Nome" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-account"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.Usuario_username" 
                    label="Email" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-email"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :disabled="disabilitaRole"
                    v-model="editedItem.passwordnew"
                    :rules="passwordRules"
                    label="Nova senha"
                    outlined
                    dense
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                    prepend-inner-icon="mdi-key"
                    placeholder="Digite a nova senha"
                    counter
                    maxlength="20"
                  >
                    <template v-slot:message="{ message }">
                      <div class="password-strength-container">
                        <v-progress-linear 
                          :value="passwordStrength(editedItem.passwordnew)" 
                          height="6" 
                          :color="getPasswordStrengthColor(passwordStrength(editedItem.passwordnew))"
                        ></v-progress-linear>
                        <div class="password-hints">
                          <span :class="{'text-success': editedItem.passwordnew && editedItem.passwordnew.length >= 8}">
                            <v-icon small>
                              {{ editedItem.passwordnew && editedItem.passwordnew.length >= 8 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                            </v-icon>
                            8+ caracteres
                          </span>
                          <span :class="{'text-success': editedItem.passwordnew && /[A-Z]/.test(editedItem.passwordnew)}">
                            <v-icon small>
                              {{ editedItem.passwordnew && /[A-Z]/.test(editedItem.passwordnew) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                            </v-icon>
                            Maiúscula
                          </span>
                          <span :class="{'text-success': editedItem.passwordnew && /[0-9]/.test(editedItem.passwordnew)}">
                            <v-icon small>
                              {{ editedItem.passwordnew && /[0-9]/.test(editedItem.passwordnew) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                            </v-icon>
                            Número
                          </span>
                        </div>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn 
                        :disabled="disabilitaRole" 
                        color="secondary" 
                        fab 
                        small 
                        v-on="on"
                        @click="GeradorSenha"
                      >
                        <v-icon>mdi-autorenew</v-icon>
                      </v-btn>
                    </template>
                    <span>Gerar senha segura</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            color="grey darken-1" 
            text 
            @click="fecharComponente"
            class="mr-2"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="#006699" 
            depressed
            dark
            :disabled="!formValid || isLoading"
            :loading="isLoading"
            @click="save"
          >
            <v-icon color="white" left>mdi-content-save</v-icon>
            Salvar Senha
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../../../plugins/axios";
import Swal from "sweetalert2";
import loading from "../../../../components/loading.vue";
const ls = require("local-storage");

export default {
  name: "mudarsenha",
  props: ["usuario"],
  components: {
    loading,
  },

  data: () => ({
    disabilitaRole: false,
    save_status: false,
    formValid: true,
    isLoading: false,
    showPassword: false,
    passwordRules: [
      (value) => !!value || "Campo obrigatório",
      (value) => value.length >= 8 || "Mínimo 8 caracteres",
      (value) => /[A-Z]/.test(value) || "Pelo menos 1 letra maiúscula",
      (value) => /[a-z]/.test(value) || "Pelo menos 1 letra minúscula",
      (value) => /[0-9]/.test(value) || "Pelo menos 1 número",
      (value) => /[^A-Za-z0-9]/.test(value) || "Pelo menos 1 caractere especial",
    ],
    dialog: true,
    editedItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
      pkUsuario: 0,
      passwordnew: "",
    },
    defaultItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
    },
  }),

  computed: {
    Instituicao() {
      return ls.get("i_id");
    },
    role() {
      return ls.get("role");
    },
  },

  created() {
    this.editedItem = Object.assign({}, this.usuario);
    this.GeradorSenha();
    this.disabilitaRole = this.usuario.autorizacoes_nome === "ROLE_EST";
  },

  methods: {
    GeradorSenha() {
      this.isLoading = true;
      try {
        let generator = require("generate-password");
        this.editedItem.passwordnew = generator.generate({
          length: 12,
          numbers: true,
          symbols: true,
          uppercase: true,
          lowercase: true,
          strict: true
        });
      } catch (error) {
        Swal.fire({
          title: "Erro",
          text: "Não foi possível gerar a senha",
          icon: "error",
          timer: 2000
        });
      } finally {
        this.isLoading = false;
      }
    },

    passwordStrength(password) {
      if (!password) return 0;
      
      let score = 0;
      // Length
      score += Math.min(25, (password.length * 3));
      
      // Contains uppercase, lowercase, numbers, symbols
      if (/[A-Z]/.test(password)) score += 15;
      if (/[a-z]/.test(password)) score += 15;
      if (/[0-9]/.test(password)) score += 15;
      if (/[^A-Za-z0-9]/.test(password)) score += 15;
      
      // Deductions for weak patterns
      if (/^[a-zA-Z]+$/.test(password)) score -= 10; // Only letters
      if (/^[0-9]+$/.test(password)) score -= 10; // Only numbers
      
      return Math.min(100, Math.max(0, score));
    },

    getPasswordStrengthColor(strength) {
      if (strength < 40) return 'red';
      if (strength < 70) return 'orange';
      return 'green';
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          const params = {
            pkUsuario: this.editedItem.pkUsuario,
            password: this.editedItem.passwordnew,
          };

          const response = await axios.post("/mudarSenhaByUser", params);
          
          if (response.data && response.data.affectedRows) {
            Swal.fire({
              title: 'Senha Alterada',
              html: `
                <div style="text-align: center;">
                  <p style="font-size: 16px; margin-bottom: 20px;">Senha atualizada com sucesso!</p>
                  <div style="background: #f5f5f5; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
                    <p style="margin: 0; font-weight: bold; color: #333;">Nova Senha:</p>
                    <p style="font-size: 24px; color: #e53935; margin: 10px 0; font-family: monospace;">${this.editedItem.passwordnew}</p>
                  </div>
                  <p style="font-size: 14px; color: #666;">Forneça esta senha ao usuário.</p>
                </div>
              `,
              icon: 'success',
              confirmButtonText: 'Entendi',
              width: 450
            });
            this.fecharComponente();
          }
        } catch (error) {
          Swal.fire({
            title: 'Erro',
            text: 'Ocorreu um erro ao alterar a senha',
            icon: 'error',
            confirmButtonText: 'Fechar'
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
    
    fecharComponente() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.$emit("fecharComponente", false);
    },
  },
};
</script>

<style scoped>
.password-card {
  border-radius: 8px;
}

.dialog-actions {
  padding: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.password-strength-container {
  margin-top: 8px;
}

.password-hints {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 0.75rem;
}

.password-hints span {
  display: flex;
  align-items: center;
}

.password-hints .v-icon {
  margin-right: 4px;
}

/* Responsividade */
@media (max-width: 600px) {
  .password-card {
    margin: 0;
    border-radius: 0;
  }
  
  .password-hints {
    flex-direction: column;
    gap: 4px;
  }
  
  .v-card__text {
    padding: 16px;
  }
}
</style>